<template>
  <div>
    <PageHeader>
      <template v-slot:header>アイコン設定</template>
      <template v-slot:annotation>
        プロフィール画像の登録をします。既に設定している場合は新しくアップロードすることで画像の変更が可能です。
      </template>
    </PageHeader>

    <v-row>
      <v-col cols="12">
        <FileInput
          v-model="input_image"
          accept=".jpg,.jpeg,.png,"
          label="画像を選択してください。"
          prepend-icon="mdi-image"
          @change="onImageChange"
          :uploadImageUrl="uploadImageUrl"
        />
      </v-col>
      <v-col cols="12" class="text-center">
        <Button @click="onImageUpload" color="primary" :disabled="loading"
          >アップロード</Button
        >
      </v-col>
    </v-row>

    <img
      v-if="uploadImageUrl"
      :src="uploadImageUrl"
      id="MyImg"
      style="display: none"
    />

    <Loader :loading="loading" />

    <DialogMessage ref="dialog" />
  </div>
</template>

<script>
import axios from 'axios';
import config from '../../../const.js';
import message from '../../../message.js';
import { imageToBase64, getSessionStorageItem } from '../../../common.js';

export default {
  data() {
    return {
      loading: false,
      input_image: null,
      uploadImageUrl: '',
      avater: '',
    };
  },
  methods: {
    onImageChange(file) {
      if (file !== undefined && file !== null) {
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        // 拡張子チェック
        if (file.type != 'image/jpeg' && file.type != 'image/png') {
          this.$refs.dialog.open('info', message.MSG_INFO_IMGTYPE_ERROR);
          return;
        }
        // ファイルサイズチェック
        let imgSizeByte = file.size;
        let imgSizeKb = Math.round(imgSizeByte / 1024);
        if (imgSizeKb > 150) {
          // 150KB以上の画像は受け付けない
          this.$refs.dialog.open('info', message.MSG_INFO_IMGSIZE_ERROR);
          return;
        }
        // ファイル読み込み
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          this.uploadImageUrl = fr.result;
        });
      } else {
        this.uploadImageUrl = '';
      }
    },
    onImageUpload() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }

      // 入力チェック
      if (this.uploadImageUrl == null || !this.uploadImageUrl.trim()) {
        this.$refs.dialog.open('info', message.MSG_INFO_AVATER_ENPTY);
        return;
      }

      // ローディング画像表示
      this.loading = true;

      let img = document.getElementById('MyImg');
      //Base64の文字列変換
      this.avater = imageToBase64(img, 'image/jpeg');

      //ユーザIDの取得
      let userAvaterName = userInfo.USER_ID;

      //----- 画像アップロードリクエストPOST
      axios
        .post(config.CONNECT_URL + '/Encouragements/thubnail', {
          USER_ID: userInfo.USER_ID,
          SESSION_ID: userInfo.SESSION_ID,
          USER_AVATER_IMAGE: this.avater,
          USER_AVATER_NAME: userAvaterName,
        })
        .then((response) => {
          // ローディング画像終了
          this.loading = false;
          let msgStr = '';
          if (response.status == 200) {
            msgStr = message.MSG_INFO_AVATER_COMPLETE;
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;
          let errStr = '';
          if (error.response.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
  },
};
</script>
